export const strokeColor = "#D5DCEA";
export const axisFormat = { stroke: strokeColor, strokeWidth: 2 };
export const firedColor = "#6E9EEC";
export const failedColor = "#E86565";
export const tickFormat = { fill: "#A9B2C1", fontSize:10, fontWeight:500 };
export const tickMargin = 5;
